import styled from 'styled-components';

export const InstallationText = styled.p`
font-size: 1.2rem;
padding: 0 0 2rem 0;
`;
